export default __webpack_public_path__ + "static/B0257-b5f024a97f3fa4fcd85527f408ef62dd.png";